import { parseEuroToCents, splitInstallments } from './installments';

// `probability` is the persisted API key for the company's percentage of the deal.
// Missing percentages retain the historical 100% share; an explicit zero stays zero.
export function getDealPercentage(deal = {}) {
  const value = deal.probability;
  if (value === null || value === undefined || String(value).trim() === '') return 100;
  return Number(String(value).replace(',', '.'));
}

export function getDealRevenueCents(deal = {}) {
  const gross = parseEuroToCents(deal.value === '' ? deal.estimatedValue : deal.value ?? deal.estimatedValue) ?? 0;
  const percentage = getDealPercentage(deal);
  if (!Number.isSafeInteger(gross) || gross < 0 || !Number.isFinite(percentage) || percentage < 0 || percentage > 100) return 0;
  const basisPoints = Math.round(percentage * 100);
  return Number((BigInt(gross) * BigInt(basisPoints) + 5000n) / 10000n);
}

export const getDealRevenue = (deal) => getDealRevenueCents(deal) / 100;

export function getDealInstallmentCents(deal = {}, count) {
  const total = getDealRevenueCents(deal);
  const amounts = deal.dilazionamento?.importiRate ?? deal.installmentAmounts?.map(parseEuroToCents);
  if (amounts?.length) {
    const sum = amounts.reduce((value, amount) => value + amount, 0);
    const gross = parseEuroToCents(deal.value === '' ? deal.estimatedValue : deal.value ?? deal.estimatedValue);
    // Older plans used the full deal value. Convert them once, retaining their proportions.
    if (sum === gross && sum > 0 && sum !== total && amounts.every((amount) => Number.isSafeInteger(amount) && amount >= 0)) {
      let cumulative = 0, previous = 0;
      return amounts.map((amount) => {
        cumulative += amount;
        const next = Number((BigInt(cumulative) * BigInt(total) * 2n + BigInt(sum)) / (2n * BigInt(sum)));
        const share = next - previous;
        previous = next;
        return share;
      });
    }
    return [...amounts];
  }
  return splitInstallments(total, count ?? deal.installmentCount ?? deal.dilazionamento?.rate
    ?? deal.installmentDueDates?.length ?? deal.dilazionamento?.scadenze?.length ?? 1);
}
